import SurveyUserIndustry from './industry';
import SurveyUserAge from './age';
import SurveyUserJob from "./job";

export {
  SurveyUserIndustry,
  SurveyUserAge,
  SurveyUserJob,
}
